import { useState } from "react";

export const useTableSearch = (initialData, searchColumns) => {
    
    const [searchValue, setSearchValue] = useState('');
    const filteredData = searchValue === ''
      ? initialData
      : initialData.filter((data) =>
          searchColumns.some(
            (column) =>
              data[column]?.toString().toLowerCase().includes(searchValue.toLowerCase())
          )
        );
  
    return { searchValue, setSearchValue, filteredData };
  };